import { Button, Checkbox, Modal } from "@aph/ui-lib";
import React, { useState } from "react";
import styles from "./PartnerConsent.module.scss";

export const PartnerConsent: React.FC<any> = (props) => {
  const [consentFormChecked, setConsentFormChecked] = useState<boolean>(false);
  const [termsOpen, setTermsOpen] = useState<boolean>(false);
  const [privacyOpen, setPrivacyOpen] = useState<boolean>(false);

  return (
    <>
      <Modal
        open={true}
        handleOpen={true}
        size={"sm"}
        closeIconHide
        modalContentClass={styles.modalContent}
        modalboxClass={styles.modalBox}
        modalClass={styles.modal}
      >
        <div className={styles.dialogContent}>
          <div className={styles.checkboxContainer}>
            <Checkbox
              color="primary"
              label="I agree to the"
              isChecked={consentFormChecked}
              onClick={(e) => {
                setConsentFormChecked(e.target.checked);
              }}
              className={styles.checkbox}
            />
            <span onClick={() => setPrivacyOpen(true)}>Privacy policy, </span>{" "}
            <span onClick={() => setTermsOpen(true)}>
              Terms and Conditions{" "}
            </span>{" "}
            of Apollo 247
          </div>
          <Button
            onClick={() => props.setIsConsentFormVisible(false)}
            color="primary"
            disabled={!consentFormChecked}
          >
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        open={termsOpen}
        handleOpen={setTermsOpen}
        size={"md"}
        modalContentClass={styles.modalContent}
      >
        <div className={styles.pdfViewContainer}>
          <iframe
            id="pdfviewer"
            src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/files/terms_and_condition_apollo247.pdf#toolbar=0&navpanes=0&scrollbar=0?embedded=true`}
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </Modal>
      <Modal
        open={privacyOpen}
        handleOpen={setPrivacyOpen}
        size={"md"}
        modalContentClass={styles.modalContent}
      >
        <div className={styles.pdfViewContainer}>
          <iframe
            id="pdfviewer"
            src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/files/privacy_policy_apollo247.pdf#toolbar=0&navpanes=0&scrollbar=0?embedded=true`}
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </Modal>
    </>
  );
};

export default PartnerConsent;
